import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { Observable } from 'rxjs/Observable';


export interface Sx_Configuracion {
  idConfiguracion: string;
  codInstalacionV5: string;
  codNegocio: string;
  codProducto: string;
  ipoConfiguracion: string;
  valor: string;
}

@Injectable()
export class SettingsService {
  private url = 'api/settings';

  constructor(private sxHttp: SxHttpService) { }

  getByLevel(tipo: string, codSistema: string = null, codNegocio: string = null, codProducto: string = null): Promise<Sx_Configuracion> {
    let url = this.url + '/' + tipo; ;

    if (codSistema) {
      url += ('/' + codSistema);
    }

    if (codNegocio) {
      url += ('/' + codNegocio);
    }

    if (codProducto) {
      url += ('/' + codProducto);
    }

    return this.sxHttp.get(url)
      .toPromise()
      .then(response => response.json().data as Sx_Configuracion);
  }

  crearOEditar(settings, codSistema: string = null, codNegocio: string = null, codProducto: string = null) {
    let url = this.url;

    if (codSistema) {
      url += ('/' + codSistema);
    }

    if (codNegocio) {
      url += ('/' + codNegocio);
    }

    if (codProducto) {
      url += ('/' + codProducto);
    }

    return this.sxHttp.post(url, settings)
        .toPromise()
        .then(response => response.json().data);
  }

  remove(tipo: string, codSistema: string = null, codNegocio: string = null, codProducto: string = null) {
    let url = this.url + '/' + tipo;

    if (codSistema) {
      url += ('/' + codSistema);
    }

    if (codNegocio) {
      url += ('/' + codNegocio);
    }

    if (codProducto) {
      url += ('/' + codProducto);
    }

    return this.sxHttp.delete(url)
        .toPromise()
        .then(response => response.json().data);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/settings.service.ts